import React from 'react'
import { useMoteDeleteMutation } from '@mote/api'
import { Block, Button, Text } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { DeleteButton } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { ReplyPlayer } from './ReplyPlayer'

export const Playback = ({
  moteId,
  audioUrl,
  onDone,
  onDelete,
  isStandalone = true
}) => {
  const { mutate: deleteMutation } = useMoteDeleteMutation(moteId)

  const handleMoteDelete = React.useCallback(async () => {
    await deleteMutation()
    onDelete()
  }, [])

  const options = React.useMemo(() => {
    return {
      init: true,
      src: audioUrl,
      isStandalone,
      playbackCallbacks: { onDelete: handleMoteDelete }
    }
  }, [audioUrl, isStandalone, handleMoteDelete])

  const { getPlayerProps } = useMotePlayer(options)

  return (
    <Root gap={16} {...getPlayerProps()}>
      <Text fontSize={14} fontWeight={400} lineHeight='120%'>
        Your reply:
      </Text>

      <ReplyPlayer replyIsMine={false} audioUrl={audioUrl} />

      <Block layout='horizontal' align='center' justify='space-between'>
        <DeleteButton
          size={40}
          aria-label='Delete (press d)'
          onClick={handleMoteDelete}
        />

        <Button aria-label='Done' text='Done' onClick={onDone} />
      </Block>
    </Root>
  )
}

const Root = styled(Block)`
  outline: none !important;
`
